import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { ASSETS } from "./questions";
import { LanguageSwitcher } from "./LanguageSwitcher";

export const SurveyHeader = ({ progress, canGoBack, onBack }) => (
  <header
    data-testid="survey-header"
    className="fixed top-0 inset-x-0 z-50 bg-white/90 backdrop-blur-md border-b border-slate-100"
  >
    <div className="h-1.5 w-full bg-slate-100" data-testid="progress-bar-track">
      <motion.div
        data-testid="progress-bar"
        className="h-full bg-gradient-to-r from-cyan-400 via-pink-500 to-yellow-400 shadow-[0_0_12px_rgba(236,72,153,0.6)]"
        initial={false}
        animate={{ width: `${progress}%` }}
        transition={{ type: "spring", stiffness: 110, damping: 20 }}
      />
    </div>
    <div className="max-w-md mx-auto flex items-center justify-between px-5 py-2.5">
      <button
        data-testid="back-button"
        onClick={onBack}
        className={`flex items-center gap-1.5 text-sm font-bold text-slate-500 hover:text-pink-500 transition-colors rounded-full px-3 py-2 -ml-3 active:scale-95 ${
          canGoBack ? "" : "opacity-0 pointer-events-none"
        }`}
        aria-hidden={!canGoBack}
      >
        <ArrowLeft size={16} strokeWidth={2.5} />
        Back
      </button>
      <span
        data-testid="progress-label"
        className="notranslate hidden sm:inline font-display text-[11px] font-extrabold tracking-[0.2em] text-slate-400"
      >
        {progress}%
      </span>
      <div className="flex items-center gap-2">
        <LanguageSwitcher />
        <img src={ASSETS.logo} alt="Ashley Falls PTA" className="h-8 w-8 shrink-0 drop-shadow-sm" />
      </div>
    </div>
  </header>
);
